import React from 'react';
import { PercentCell } from './PercentCell';
import { section } from './rows';
import { formatMeasure, formatPercent } from './units';

/** Energy: fuel for combustion vehicles, charge for electric ones, the 12 V battery for both. */
export const energySections = (view, ctx) => {
	const { t } = ctx;
	const label = (key) => t(`oemDataModal_cerebrumx_energy_${key}`);
	const percentCell = (value, key) => {
		if (value === undefined) return undefined;
		return <PercentCell value={value} label={label(key)} ctx={ctx} />;
	};
	const measureRow = (key, measure, icon = 'local_gas_station') => ({
		key,
		icon,
		label: label(key),
		value: formatMeasure(measure, ctx),
	});

	return [
		section(
			'fuel',
			[
				{
					key: 'fuelLevel',
					icon: 'local_gas_station',
					label: label('fuelLevel'),
					value: percentCell(view.fuelLevel?.value, 'fuelLevel'),
				},
				measureRow('distanceToEmpty', view.distanceToEmpty, 'route'),
				measureRow('absFuelLevel', view.absFuelLevel),
				measureRow('fuelTankCapacity', view.fuelTankCapacity),
				measureRow('instantConsumption', view.instantConsumption),
				measureRow('totalFuelConsumed', view.totalFuelConsumed),
				measureRow('totalFuelEconomy', view.totalFuelEconomy),
			],
			label('fuel'),
		),
		section(
			'electric',
			[
				{
					key: 'evLevel',
					icon: 'battery_charging_full',
					label: label('evLevel'),
					value: percentCell(view.evLevel, 'evLevel'),
				},
				{
					key: 'absEvLevel',
					icon: 'battery_charging_full',
					label: label('absEvLevel'),
					value: formatPercent(view.absEvLevel, ctx),
				},
			],
			label('electric'),
		),
		section('battery', [measureRow('batteryVoltage', view.batteryVoltage, 'battery_full')], label('battery')),
	];
};
